/*@flow*/
import * as I from 'immutable';
import collPaths from 'lib/collPaths';

type IMap = I.Map<string, I.Map<*, *>>;

export default (a: IMap, b: IMap): IMap => {
  // Build a list of all key paths to be removed in the query object.
  const kps = collPaths(b);
  kps.forEach((kp: I.List<ID>) => {
    // $FlowFixMe[incompatible-call]
    a = a.deleteIn(kp);
    let list = kp;
    let terminate = list.isEmpty();
    while (!terminate && a) {
      let path = kp.butLast();
      const butLastValue = a.getIn(path);
      if (butLastValue && butLastValue.isEmpty() && a) {
        a = a.deleteIn(path.butLast()) || I.Map();
      } else {
        terminate = true;
      }
      list = path;
    }
  });

  return a;
};
